// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"94":"a0f37d01","224":"59905909","506":"c6041058","572":"b1c42d73","828":"1074efdc"}[chunkId] + ".css";
};